import React from 'react';
import { useTranslation } from 'react-i18next';
import icon from '../../img/start-again.svg';

// using image found at
// https://extranet.medel.com/downloads-center/corporate-design-guide
function StartAgain() {
  const { t } = useTranslation();

  return (
    <div className="start-again mb-4 d-flex justify-content-center">
      <button
        className="btn-img"
        type="button"
        onClick={(e) => window.location.reload()}
      >
        <img className="img-fluid" alt={t('common.startAgain')} src={icon} />
        {` ${t('common.startAgain')}`}
      </button>
    </div>
  );
}

export default StartAgain;
